
import { CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Bell } from "lucide-react";

interface NotificationsSectionProps {
  profile: {
    email_reminders: boolean;
    sms_notifications: boolean;
    phone: string | null;
  };
  onProfileChange: (key: string, value: boolean | string) => void;
}

export function NotificationsSection({ profile, onProfileChange }: NotificationsSectionProps) {
  return (
    <>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Bell className="h-5 w-5" />
          Notifications
        </CardTitle>
        <CardDescription>Manage your notification preferences</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Email Reminders</Label>
            <p className="text-sm text-muted-foreground">Receive updates and reminders via email</p>
          </div>
          <Switch
            checked={profile.email_reminders}
            onCheckedChange={(checked) => onProfileChange("email_reminders", checked)}
          />
        </div>
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>SMS Notifications</Label>
            <p className="text-sm text-muted-foreground">Receive updates via text message</p>
          </div>
          <Switch
            checked={profile.sms_notifications}
            onCheckedChange={(checked) => onProfileChange("sms_notifications", checked)}
          />
        </div>
        {profile.sms_notifications && (
          <div className="space-y-2">
            <Label htmlFor="phone">Phone Number</Label>
            <Input
              id="phone"
              type="tel"
              placeholder="+1 (555) 000-0000"
              value={profile.phone || ""}
              onChange={(e) => onProfileChange("phone", e.target.value)}
            />
          </div>
        )}
      </CardContent>
    </>
  );
}
